import { render, staticRenderFns } from "./Door.vue?vue&type=template&id=7a3812da&scoped=true"
import script from "./Door.vue?vue&type=script&lang=js"
export * from "./Door.vue?vue&type=script&lang=js"
import style0 from "./Door.vue?vue&type=style&index=0&id=7a3812da&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a3812da",
  null
  
)

export default component.exports